import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Select from "../../form/Select";
import DateTimeInput from "../../form/DateTimeInput";
import CheckBox from "../../form/CheckBox";
import TypeTextEditor from "../../form/TypeTextEditor";
import Collapse from "../../layout/Collapse";
import connect from "react-redux/es/connect/connect";
import createEditor from "../../form/ComponentEditor";

class EventForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-2">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-md-5">
                        <Select
                            component="Program"
                            name="program"
                            value={this.props.values.program}
                            label="Program"
                            labelKey="name"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("program")}
                        />
                    </div>
                    <div className="col-md-5">
                        <Select
                            component="location"
                            name="locations"
                            isMulti={true}
                            value={this.props.values.locations}
                            label="Helyszín"
                            labelKey="name"
                            filter={[
                                {
                                    field: "partner",
                                    value: this.props.till.pos.partner.partner_id
                                }
                            ]}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("locations")}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("from")}
                            name="from"
                            value={this.props.values.from}
                            label="Tól"
                            showTime={true}
                            maxDate={this.props.values.to}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("to")}
                            name="to"
                            value={this.props.values.to}
                            label="Ig"
                            showTime={true}
                            minDate={this.props.values.from}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-2">
                        <label className="control-label">&nbsp;</label>
                        <CheckBox
                            name="public"
                            value={this.props.values.public}
                            label="Publikus"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("public")}
                        />
                    </div>
                    {this.props.values[this.props.componentConfig.idfield] && <div className="col-md-2">
                        <label className="control-label">&nbsp;</label>
                        <CheckBox
                            name="canceled"
                            value={this.props.values.canceled}
                            label="Elmarad"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("canceled")}
                        />
                    </div>}
                    {!this.props.values[this.props.componentConfig.idfield] && <div className="col-md-2">
                        <label className="control-label">&nbsp;</label>
                        <CheckBox
                            name="repeated"
                            value={this.props.values.repeated}
                            label="Többszöri esemény"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("repeated")}
                        />
                    </div>}
                </div>
                <Collapse collapsed={!!parseInt(this.props.values.canceled)}>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <TypeTextEditor
                                name="canceled_description"
                                label="Elmaradás oka"
                                data={this.props.values}
                                componentConfig={this.props.componentConfig}
                                getFieldProps={this.props.getFieldProps}
                                setFieldValue={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </Collapse>
            </form>
        );
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    }
})(createForm(EventForm));
